import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";

export class EditableFormatLayerImageSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public key: string) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/format/" + this.formatId + "/background/" + this.key + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatLayerImageSource(
      this._getToken,
      this.formatId,
      this.key
    );
  }
}
